import upfTheme from './upf-theme';

export default upfTheme;
